import { getLocalTime } from '@qualle-admin/qutil/dist/date';

const formatDate = (value) => {
  if (value) {
    return getLocalTime(value).format('MM/DD/YYYY');
  }
};

const formatLfdDate = (value) => {
  if (value) {
    return getLocalTime(value).format('MM/DD');
  }
};

const formatCommentDate = (value) => {
  if (value) {
    return getLocalTime(value).format('MM/DD/YYYY hh:mm A');
  }
};

const formatCreatedDate = (value) => {
  if (value) {
    return getLocalTime(value).format('MM/DD/YYYY hh:mm A');
  }
};

const formatPaymentDate = (value) => {
  if (value) {
    return getLocalTime(value).format('MM/DD/YYYY hh:mm A');
  }
};

const formatTimestampDate = (value) => {
  if (value) {
    return getLocalTime(value).format('MM/DD/YYYY hh:mm A');
  }
};

const formatNotificationDate = (date) => {
  const REFERENCE = getLocalTime();
  const momentDate = getLocalTime(date);
  const TODAY = REFERENCE.clone().startOf('day');
  const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
  const BEGINNING_OF_WEEK = REFERENCE.clone().startOf('week');
  const A_WEEK_OLD = REFERENCE.clone().subtract(7, 'days').startOf('week');
  const dateFormat = 'MM/DD/YYYY';
  let returnValue = '';

  switch (true) {
    case momentDate.isSame(TODAY, 'd'):
      returnValue = 'Today';
      break;
    case momentDate.isSame(YESTERDAY, 'd'):
      returnValue = 'Yesterday';
      break;
    case momentDate.isBefore(A_WEEK_OLD):
      returnValue = momentDate.format(dateFormat);
      break;
    case momentDate.isBefore(BEGINNING_OF_WEEK):
      returnValue = 'Last Week';
      break;
    case momentDate.isBefore(YESTERDAY):
      returnValue = momentDate.format('dddd');
      break;
    default:
      returnValue = momentDate.format(dateFormat);
  }

  return returnValue;
};

export default {
  install(Vue) {
    Vue.filter('formatDate', formatDate);
    Vue.filter('formatLfdDate', formatLfdDate);
    Vue.filter('formatCommentDate', formatCommentDate);
    Vue.filter('formatCreatedDate', formatCreatedDate);
    Vue.filter('formatPaymentDate', formatPaymentDate);
    Vue.filter('formatTimestampDate', formatTimestampDate);
    Vue.filter('formatNotificationDate', formatNotificationDate);
  },
};
